<template>
    <AppLayout :contrast="true" title="Editar Cliente Global">
        <Breadcrumb
            name="Clientes Globales"
            routeName="clientes_globales"
            page="Editar Cliente Global"
        />

        <form class="p-2">
            <div class="flex flex-col lg:flex-row lg:w-full">
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-1/2"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Datos Básicos
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="nombre" class="my-1 text-gray-700">
                            Nombre<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="name"
                            id="nombre"
                            :class="[
                                't-input',
                                form.errors.nombre && 't-input-invalid',
                            ]"
                            v-model="form.nombre"
                            required
                            @focus="form.errors.nombre = null"
                        />
                        <small
                            v-if="form.errors.nombre"
                            id="nombre-help"
                            class="p-error"
                        >
                            {{ form.errors.nombre }}
                        </small>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="descripcion" class="my-1 text-gray-700">
                            Descripción
                        </label>
                        <input
                            type="text"
                            id="descripcion"
                            :class="[
                                't-input',
                                form.errors.descripcion && 't-input-invalid',
                            ]"
                            v-model="form.descripcion"
                            @focus="form.errors.descripcion = null"
                        />
                        <small
                            v-if="form.errors.descripcion"
                            id="descripcion-help"
                            class="p-error"
                        >
                            {{ form.errors.descripcion }}
                        </small>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="razon_social" class="my-1 text-gray-700">
                            Razon Social
                        </label>
                        <input
                            type="text"
                            id="razon_social"
                            :class="[
                                't-input',
                                form.errors.razon_social && 't-input-invalid',
                            ]"
                            v-model="form.razon_social"
                            @focus="form.errors.razon_social = null"
                        />
                        <small
                            v-if="form.errors.razon_social"
                            id="razon_social-help"
                            class="p-error"
                        >
                            {{ form.errors.razon_social }}
                        </small>
                    </div>
                </div>
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-1/2"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Información de Contacto
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="contacto" class="my-1 text-gray-700">
                            Contacto
                        </label>
                        <input
                            type="text"
                            id="contacto"
                            :class="[
                                't-input',
                                form.errors.contacto && 't-input-invalid',
                            ]"
                            v-model="form.contacto"
                            @focus="form.errors.contacto = null"
                        />
                        <small
                            v-if="form.errors.contacto"
                            id="contacto-help"
                            class="p-error"
                        >
                            {{ form.errors.contacto }}
                        </small>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="telefono" class="my-1 text-gray-700">
                            Telefono<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="tel"
                            id="telefono"
                            :class="[
                                't-input',
                                form.errors.telefono && 't-input-invalid',
                            ]"
                            v-model="form.telefono"
                            required
                            @focus="form.errors.telefono = null"
                        />
                        <small
                            v-if="form.errors.telefono"
                            id="telefono-help"
                            class="p-error"
                        >
                            {{ form.errors.telefono }}
                        </small>
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="email" class="my-1 text-gray-700">
                            Email<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="email"
                            id="email"
                            :class="[
                                't-input',
                                form.errors.email && 't-input-invalid',
                            ]"
                            v-model="form.email"
                            required
                            @focus="form.errors.email = null"
                        />
                        <small
                            v-if="form.errors.email"
                            id="email-help"
                            class="p-error"
                        >
                            {{ form.errors.email }}
                        </small>
                    </div>
                </div>
            </div>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="update">Editar Cliente Global</Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: ["clientes_globale"],
    data() {
        return {
            form: this.$inertia.form({
                nombre: this.$props.clientes_globale.nombre,
                descripcion: this.$props.clientes_globale.descripcion,
                razon_social: this.$props.clientes_globale.razon_social,
                contacto: this.$props.clientes_globale.contacto,
                telefono: this.$props.clientes_globale.telefono,
                email: this.$props.clientes_globale.email,
            }),
        };
    },
    methods: {
        update() {
            this.form.put("/clientes_globales/" + this.clientes_globale.id);
        },
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>
